const nlLocale = {
    days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    daysShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    daysMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    today: "Vandaag",
    clear: "Legen",
    dateFormat: "dd-MM-yyyy",
    timeFormat: "HH:mm",
    firstDay: 0,
};

/** Next-day delivery order cutoff (Europe/Amsterdam wall clock). */
const NEXT_DAY_CUTOFF_HOUR_NL = 20;
const NEXT_DAY_CUTOFF_HOUR_BE = 16;

const PPC_DATE_CONFIG_NL = [
    // ---- UITGESLOTEN / GEEN LEVERDAGEN ----
    { start: 1011, end: 1018, days: [] },
    { start: 1790, end: 1797, days: [] },
    { start: 8880, end: 8899, days: [] },
    { start: 9160, end: 9166, days: [] },

    // ---- MA + WO + VR ----
    { start: 1001, end: 1789, days: ["Ma", "Wo", "Vr"] },
    { start: 1800, end: 2254, days: ["Ma", "Wo", "Vr"] },
    { start: 2311, end: 2481, days: ["Ma", "Wo", "Vr"] },
    { start: 3440, end: 3455, days: ["Ma", "Wo", "Vr"] },
    { start: 3470, end: 3545, days: ["Ma", "Wo", "Vr"] },
    { start: 3551, end: 3907, days: ["Ma", "Wo", "Vr"] },
    { start: 3925, end: 3985, days: ["Ma", "Wo", "Vr"] },
    { start: 6710, end: 6718, days: ["Ma", "Wo", "Vr"] },
    { start: 6730, end: 6745, days: ["Ma", "Wo", "Vr"] },
    { start: 6877, end: 6877, days: ["Ma", "Wo", "Vr"] },
    { start: 7300, end: 7364, days: ["Ma", "Wo", "Vr"] },
    { start: 7384, end: 7397, days: ["Ma", "Wo", "Vr"] },
    { start: 7400, end: 7437, days: ["Ma", "Wo", "Vr"] },
    { start: 8000, end: 8294, days: ["Ma", "Wo", "Vr"] },

    // ---- MA + DI + DO ----
    { start: 2260, end: 2303, days: ["Ma", "Di", "Do"] },
    { start: 2490, end: 2761, days: ["Ma", "Di", "Do"] },
    { start: 2770, end: 2771, days: ["Ma", "Di", "Do"] },
    { start: 2800, end: 3439, days: ["Ma", "Di", "Do"] },
    { start: 3460, end: 3467, days: ["Ma", "Di", "Do"] },
    { start: 3546, end: 3546, days: ["Ma", "Di", "Do"] },
    { start: 3910, end: 3922, days: ["Ma", "Di", "Do"] },
    { start: 3989, end: 4288, days: ["Ma", "Di", "Do"] },
    { start: 4600, end: 5872, days: ["Ma", "Di", "Do"] },
    { start: 6500, end: 6709, days: ["Ma", "Di", "Do"] },
    { start: 6720, end: 6721, days: ["Ma", "Di", "Do"] },
    { start: 6800, end: 6874, days: ["Ma", "Di", "Do"] },
    { start: 6880, end: 6999, days: ["Ma", "Di", "Do"] },
    { start: 7370, end: 7383, days: ["Ma", "Di", "Do"] },
    { start: 7399, end: 7399, days: ["Ma", "Di", "Do"] },

    // ---- DI + DO ----
    { start: 4300, end: 4589, days: ["Di", "Do"] },
    { start: 5900, end: 6471, days: ["Di", "Do"] },
    { start: 6500, end: 6709, days: ["Di", "Do"] },
    { start: 7000, end: 7275, days: ["Di", "Do"] },
    { start: 7440, end: 7696, days: ["Di", "Do"] },

    // ---- WO + VR ----
    { start: 7400, end: 7437, days: ["Wo", "Vr"] },
    { start: 7439, end: 7439, days: ["Wo", "Vr"] },
    { start: 7700, end: 7991, days: ["Wo", "Vr"] },
    { start: 8300, end: 8872, days: ["Wo", "Vr"] },
    { start: 8900, end: 9156, days: ["Wo", "Vr"] },
    { start: 9171, end: 9999, days: ["Wo", "Vr"] },
];

const PPC_DATE_CONFIG_BE = [
    // ---- UITGESLOTEN / GEEN LEVERDAGEN ----
    { start: 47, end: 49, days: [] },
    { start: 54, end: 56, days: [] },
    { start: 63, end: 69, days: [] },

    // ---- WOENSDAG + VRIJDAG ----
    { start: 10, end: 12, days: ["Wo", "Vr"] },
    { start: 14, end: 19, days: ["Wo", "Vr"] },
    { start: 77, end: 99, days: ["Wo", "Vr"] },

    // ---- DINSDAG + DONDERDAG ----
    { start: 13, end: 13, days: ["Di", "Do"] },
    { start: 20, end: 39, days: ["Di", "Do"] },
    { start: 42, end: 44, days: ["Di", "Do"] },
    { start: 46, end: 46, days: ["Di", "Do"] },

    // ---- MAANDAG ----
    { start: 72, end: 72, days: ["Ma"] },
    { start: 74, end: 74, days: ["Ma"] },

    // ---- DONDERDAG ----
    { start: 40, end: 41, days: ["Do"] },
    { start: 45, end: 45, days: ["Do"] },
    { start: 50, end: 53, days: ["Do"] },

    // ---- VRIJDAG ----
    { start: 60, end: 62, days: ["Vr"] },
    { start: 70, end: 76, days: ["Vr"] },
];

class DeliveryDatePicker extends HTMLElement {
    constructor() {
        super();

        this._usePpcDates = this.getAttribute("uses-ppc-dates") === "true";
        this._containsFloor = this.getAttribute("contains-floor") === "true";
        this._firstAvailableDate = this.getAttribute("first-available-date");

        this._zipCode = this.getAttribute("zipcode") || null;
        this._selectedDate = this.getAttribute("selected-date") || null;
        this._country = this.getAttribute("country") || (window.location.origin.split(".").pop() === "be" ? "BE" : "NL");
        this._activeDays = [];
        this.datePicker;

        this._isLoading = false;
    }

    // ==============================
    // GETTERS & SETTERS
    // ==============================

    get country() {
        return this._country;
    }

    set country(value) {
        this._country = value;
        this._updateCountry();
        this._updateDatePicker();
    }

    get zipCode() {
        return this._zipCode;
    }

    set zipCode(value) {
        this._zipCode = value;
        this._updateDatePicker();
    }

    get selectedDate() {
        return this._selectedDate;
    }

    set selectedDate(value) {
        this._selectedDate = value;
    }

    get isLoading() {
        return this._isLoading;
    }

    set isLoading(value) {
        this._isLoading = value;
        this._toggleLoader(value);
    }

    // ==============================
    // SETUP & LIFECYCLE
    // ==============================

    connectedCallback() {
        this.render();
    }

    async render() {
        this.innerHTML = `
            <div class="delivery-date__address">
                <div class="delivery-date__input-group input__country">
                    <label for="country">Land</label>
                    <select id="country" name="country">
                        <option value="NL" ${this.country != "BE" ? "selected" : ""}>NL</option>
                        <option value="BE" ${this.country === "BE" ? "selected" : ""}>BE</option>
                    </select>
                </div>
                <div class="delivery-date__input-group input__zipcode">
                    <label for="zipcode">Postcode</label>
                    <input type="text" id="zipcode" name="zipcode" placeholder="1234 AB" value="${this._zipCode ?? ""}"/>
                </div>
            </div>
            <div class="delivery-date__input-group input__datepicker">
                <label for="delivery-date">Kies een beschikbare bezorgdatum*</label>
                <div class="input__group">
                    <input readonly type="text" id="delivery-date" name="delivery-date" value="${this._selectedDate ?? ""}" disabled />
                    <i class="fa-regular fa-spinner fa-spin"></i>
                </div>
            </div>
            <div class="delivery-date__notice" aria-hidden="true">
                <i class="fa-regular fa-check"></i>
                <span class="delivery-date__notice-text"></span>
            </div>
        `;

        this._initDatePicker();
        this._initListeners();

        // Keep the date field hidden until a valid postcode is entered. We hide
        // it AFTER init (not via display:none in the markup) so AirDatepicker
        // builds its calendar while the field is visible — initialising it
        // inside a display:none wrapper breaks the per-postcode day disabling.
        if (!this._zipCode) {
            this._hideDatePickerWrap();
        }
    }

    // ==============================
    // PRIVATE METHODS
    // ==============================

    _showDatePickerWrap() {
        const wrap = this.querySelector(".input__datepicker");
        if (wrap) wrap.style.display = "";
    }

    _hideDatePickerWrap() {
        const wrap = this.querySelector(".input__datepicker");
        if (wrap) wrap.style.display = "none";
    }

    /**
     * Initialize event listeners for user interactions.
     */
    _initListeners() {
        const zipcodeInput = this.querySelector("#zipcode");
        zipcodeInput.addEventListener("input", (event) => {
            this._validateZipCode(event.target);
        });

        const countrySelect = this.querySelector("#country");
        countrySelect.addEventListener("change", (event) => {
            this.country = event.target.value;
        });
    }

    /**
     * Initialize the date picker component with localization and selection logic.
     */
    async _initDatePicker() {
        // Aan het eigen veld binden, niet aan de eerste #delivery-date in het document:
        // de winkelwagen-drawer staat ook als sjabloon in de pagina, dus deze id komt dubbel voor.
        this.datePicker = new AirDatepicker(this.querySelector("#delivery-date"), {
            locale: nlLocale,
            firstDay: 1,
            minDate: new Date(new Date().getTime() + (this._containsFloor ? 72 : 24) * 60 * 60 * 1000),
            onSelect: ({ date, formattedDate, picker }) => {
                this.selectedDate = date;
                this.datePicker.hide();

                this._setCartAttributes({
                    delivery_date: formattedDate,
                    zip_code: this.zipCode,
                    country: this.country,
                })
                    .then(() => {
                        this._setNotice(`Leverdatum: ${formattedDate} geselecteerd`, false);
                    })
                    .catch(() => {
                        this._setNotice("Er is een fout opgetreden bij het opslaan van de levertijd.", true);
                    });
            },
            onRenderCell: ({ date }) => {
                return this._renderDatePickerCell(date);
            },
        });

        this.validateDateSelection();
    }

    /**
     * Validate the currently selected date against the current configuration.
     * @returns {Boolean} Whether the selected date is valid
     */
    async validateDateSelection() {
        if (this._selectedDate) {
            if (!this._zipCode || !this._country) {
                // clear delivery date
                this.selectedDate = null;
                this.datePicker.clear();
                this._clearDeliveryDateFromCart();
                return true;
            }

            this._updateDatePicker(false);

            // check if the selected date is valid. Als lokale dag inlezen: Liquid levert "2026-10-06" en
            // new Date() maakt daar UTC-middernacht van (02:00 in NL). Dan herkende de "morgen na de
            // cutoff"-regel hem nooit en bleef een 's middags gekozen dag 's avonds staan (#8053165).
            const selectedDateObj = this._lokaleDag(this._selectedDate);
            if (selectedDateObj && this.gekozenDagMag(selectedDateObj)) {
                this.datePicker.selectDate(selectedDateObj);
                return true;
            } else {
                // clear delivery date
                this.selectedDate = null;
                this.datePicker.clear();

                // clear zip code
                this.zipCode = null;
                this.querySelector("#zipcode").value = "";

                this._setNotice("De eerder geselecteerde bezorgdatum is niet langer beschikbaar. Kies een nieuwe datum.", true);
                this._clearDeliveryDateFromCart();
                return false;
            }
        }

        return true;
    }

    /**
     * Een datum als lokale middernacht, uit een Date, "YYYY-MM-DD" (Liquid) of "DD-MM-YYYY" (cart-attribuut).
     * @returns {Date|null}
     */
    _lokaleDag(waarde) {
        if (!waarde) return null;
        if (waarde instanceof Date) {
            if (isNaN(waarde.getTime())) return null;
            return new Date(waarde.getFullYear(), waarde.getMonth(), waarde.getDate());
        }
        const tekst = String(waarde).trim();
        let m = tekst.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        m = tekst.match(/^(\d{2})-(\d{2})-(\d{4})$/);
        if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
        return null;
    }

    /**
     * Mag deze dag NU nog? Dezelfde regels als de kalender: de minimale doorlooptijd (minDate, per dag)
     * plus _renderDatePickerCell (weekend, cutoff, regiodagen). Bij het laden én bij het afrekenen,
     * want tussen kiezen en afrekenen kunnen uren zitten.
     */
    gekozenDagMag(dag) {
        const vroegste = new Date(Date.now() + (this._containsFloor ? 72 : 24) * 60 * 60 * 1000);
        vroegste.setHours(0, 0, 0, 0);
        if (dag < vroegste) return false;
        return !this._renderDatePickerCell(dag).disabled;
    }

    /**
     * Staat er een gekozen datum die inmiddels niet meer mag? Synchroon, zodat de afreken-controle
     * hieronder kan ingrijpen vóór de browser naar /checkout gaat.
     */
    heeftVerlopenDatum() {
        if (!this._selectedDate || !this._zipCode || !this._country) return false;
        if (this._usePpcDates && !(this._activeDays && this._activeDays.length)) this._updateDatePicker(false);
        const dag = this._lokaleDag(this._selectedDate);
        return !dag || !this.gekozenDagMag(dag);
    }

    /**
     * Wist alleen de verlopen datum; de postcode blijft staan, zodat de klant direct een nieuwe dag kan kiezen.
     */
    async verlopenDatumWissen() {
        this.selectedDate = null;
        this.datePicker.clear({ silent: true });
        await this._setCartAttributes({ delivery_date: null });
        // Kalender (winkelwagenpagina) en dagknoppen (drawer) opnieuw opbouwen op dezelfde postcode.
        const veld = this.querySelector("#zipcode");
        if (veld && veld.value) veld.dispatchEvent(new Event("input", { bubbles: true }));
        const blok = this.closest("details");
        if (blok && !blok.open) blok.open = true;
        this._setNotice("De gekozen bezorgdatum is niet meer beschikbaar. Kies een nieuwe datum en reken daarna af.", true);
        this.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    /**
     * Render logic for each date cell in the date picker.
     * @param {Date} date The date to render
     * @returns {Object} Cell options including disabled state
     */
    _renderDatePickerCell(date) {
        const dayOfWeek = nlLocale.daysShort[date.getDay()];
        const tomorrow = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);

        // Disable weekends
        if (dayOfWeek == "Za" || dayOfWeek == "Zo") {
            return {
                disabled: true,
            };
        }

        // Disable dates before the first available date
        const firstDate = this._firstAvailableDate ? new Date(`${this._firstAvailableDate}T00:00:00`) : null;
        if (firstDate && date < firstDate) {
            return {
                disabled: true,
            };
        }

        // Disable excluded dates set in a js constant from liquid
        if (EXCLUDED_DATES && EXCLUDED_DATES.some((excludedDate) => excludedDate.toDateString() === date.toDateString())) {
            return {
                disabled: true,
            };
        }

        // Get current time info in Amsterdam timezone
        const today = new Date();
        const dayToday = today.getDay();
        const hourInAMS = Number(
            new Intl.DateTimeFormat("nl-NL", {
                timeZone: "Europe/Amsterdam",
                hour: "numeric",
                hour12: false,
            }).format(new Date()),
        );

        const nextDayCutoffHour = this._country === "BE" ? NEXT_DAY_CUTOFF_HOUR_BE : NEXT_DAY_CUTOFF_HOUR_NL;

        // Op de dag vergelijken: een datum die niet precies op middernacht staat telde anders niet als morgen.
        const dagStart = new Date(date);
        dagStart.setHours(0, 0, 0, 0);

        // Disable the date of tomorrow if the time is past the country-specific cutoff (Amsterdam)
        if (dagStart.getTime() == tomorrow.getTime() && hourInAMS >= nextDayCutoffHour) {
            return { disabled: true };
        }

        // if today is friday after cutoff, saturday or sunday, disable the next monday
        if (dayOfWeek === "Ma") {
            if (
                (dayToday === 5 && hourInAMS >= nextDayCutoffHour) || // Friday after cutoff
                dayToday === 6 || // Saturday
                dayToday === 0 // Sunday
            ) {
                // Calculate the date of next Monday
                let daysUntilMonday;
                if (dayToday === 0) {
                    daysUntilMonday = 1;
                } else if (dayToday === 5) {
                    daysUntilMonday = 3;
                } else if (dayToday === 6) {
                    daysUntilMonday = 2;
                }

                const nextMonday = new Date(today);
                nextMonday.setDate(today.getDate() + daysUntilMonday);
                nextMonday.setHours(0, 0, 0, 0);

                const dateToCheck = new Date(date);
                dateToCheck.setHours(0, 0, 0, 0);

                // Only disable if this date is the next Monday
                if (dateToCheck.getTime() === nextMonday.getTime()) {
                    return { disabled: true };
                }
            }
        }

        // Disable dates based on active days from PPC configuration
        if (this._usePpcDates) {
            if (this._activeDays.includes(dayOfWeek)) {
                return {
                    disabled: false,
                };
            } else {
                return {
                    disabled: true,
                };
            }
        }

        // Disable tommorow's date if order is post order
        if (!this._usePpcDates && !this._containsFloor) {
            if (dagStart.getTime() === tomorrow.getTime()) {
                return { disabled: true };
            }
        }

        return { disabled: false };
    }

    /**
     * Update the component when the country changes.
     */
    async _updateCountry() {
        // clear the zipcode when country changes
        this.zipCode = null;
        this.selectedDate = null;
        this.datePicker.clear();

        // update placeholder
        const zipcodeInput = this.querySelector("#zipcode");
        zipcodeInput.value = "";

        await this._setCartAttributes({
            delivery_date: null,
            zip_code: null,
            country: null,
        });

        if (this._country === "NL") {
            zipcodeInput.placeholder = "1234 AB";
        } else if (this._country === "BE") {
            zipcodeInput.placeholder = "1234";
        }
    }

    /**
     * Validate and format the zip code input.
     * @param {HTMLElement} input The zip code input element
     */
    _validateZipCode(input) {
        let value = input.value.toUpperCase().replace(/[^0-9A-Z\s]/g, "");
        let isValid = false;

        if (this._country === "NL") {
            // Dutch format: 1234 AB
            if (value.length > 4) {
                value = value.slice(0, 4) + " " + value.slice(4).replace(/\s/g, "");
            }
            value = value.slice(0, 7);
            isValid = /^\d{4}\s[A-Z]{2}$/.test(value);
        } else if (this._country === "BE") {
            // Belgian format: 1234 (numbers only)
            value = value.replace(/[^0-9]/g, "");
            value = value.slice(0, 4);
            isValid = /^\d{4}$/.test(value);
        }

        input.value = value;
        this.zipCode = isValid ? value : null;
    }

    /**
     * Update the date picker based on the current zip code and active days.
     * Shows the datepicker wrap when a valid postcode is set, hides it when not.
     */
    _updateDatePicker(openPicker = true) {
        this._clearNotice();

        if (this.zipCode == null) {
            this._hideDatePickerWrap();
            this.querySelector("#delivery-date").disabled = true;
            return;
        }

        // Valid postcode — make the datepicker visible
        this._showDatePickerWrap();
        this.querySelector("#delivery-date").disabled = false;

        // Determine active days based on zip code
        let dayConfig;

        if (this._country === "NL") {
            const zipNum = parseInt(this.zipCode.slice(0, 4), 10);
            dayConfig = PPC_DATE_CONFIG_NL.filter((config) => zipNum >= config.start && zipNum <= config.end);
        } else if (this._country === "BE") {
            const zipNum = parseInt(this.zipCode.slice(0, 2), 10);
            dayConfig = PPC_DATE_CONFIG_BE.filter((config) => zipNum >= config.start && zipNum <= config.end);
        }

        if (this._usePpcDates && (dayConfig == null || dayConfig == undefined || dayConfig.findIndex((config) => config.days.length == 0) !== -1)) {
            this._activeDays = [];

            this.selectedDate = null;
            this.datePicker.clear();

            this._setCartAttributes({
                delivery_date: null,
                zip_code: this.zipCode,
            }).then(() => {
                this._setNotice("Het bezorgen van een of meer producten in je winkelwagen is helaas niet mogelijk voor de ingevoerde postcode.", true);
                this.querySelector("#delivery-date").disabled = true;
            });
        } else {
            this._activeDays = dayConfig.flatMap((config) => config.days);
            // Open de kalender op de eerste maand mét leverdagen. Alleen hier (postcode geldig
            // én er zijn actieve leverdagen), nooit op load — zo kan de picker niet vastlopen
            // in een maand waar alle dagen disabled zijn. setViewDate bestaat in AirDatepicker 3.6.
            if (this._firstAvailableDate && this.datePicker && typeof this.datePicker.setViewDate === "function") {
                const firstAvail = new Date(`${this._firstAvailableDate}T00:00:00`);
                if (!isNaN(firstAvail.getTime()) && firstAvail > new Date()) {
                    this.datePicker.setViewDate(firstAvail);
                }
            }
            this._syncBackorderNotice();
            if (openPicker) {
                this.datePicker.show();
            }
        }
    }

    /**
     * Zet in de backorder-melding(en) de eerste écht selecteerbare bezorgdag
     * (floor + actieve leverdagen van de regio), zodat de melding-datum exact de
     * datepicker spiegelt (03-09 floor → 04-09 eerste leverdag). Loopt bounded.
     */
    _syncBackorderNotice() {
        const els = document.querySelectorAll("[data-vm-eerste-datum]");
        if (!els.length) return;
        const start = this._firstAvailableDate ? new Date(`${this._firstAvailableDate}T00:00:00`) : new Date();
        const probe = new Date(start);
        probe.setHours(0, 0, 0, 0);
        let found = null;
        for (let i = 0; i < 120; i++) {
            if (!this._renderDatePickerCell(probe).disabled) {
                found = new Date(probe);
                break;
            }
            probe.setDate(probe.getDate() + 1);
        }
        if (!found) return;
        const dd = String(found.getDate()).padStart(2, "0");
        const mm = String(found.getMonth() + 1).padStart(2, "0");
        const txt = `${dd}-${mm}-${found.getFullYear()}`;
        els.forEach((el) => {
            el.textContent = txt;
        });
    }

    /**
     * Adds or updates cart attributes via Shopify's cart API.
     * @param {Object} attributes The attributes to set on the cart
     */
    async _setCartAttributes(attributes) {
        this.isLoading = true;

        await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                attributes: attributes,
            }),
        });

        this.isLoading = false;
    }

    /**
     * Shows a notice message to the user under the postcode input field.
     * @param {String} message the message to display
     * @param {Boolean} isError whether the message is an error
     * @param {Number} clearAfter optional time in ms after which the message will be cleared
     */
    _setNotice(message, isError, clearAfter) {
        const noticeElement = this.querySelector(".delivery-date__notice");
        const noticeText = noticeElement.querySelector(".delivery-date__notice-text");

        noticeText.textContent = message;

        if (isError) {
            noticeElement.classList.add("delivery-date__notice--error");
        } else {
            noticeElement.classList.remove("delivery-date__notice--error");
        }

        noticeElement.setAttribute("aria-hidden", "false");

        if (clearAfter) {
            setTimeout(() => {
                this._clearNotice();
            }, clearAfter);
        }
    }

    /**
     * Clears any existing notice message.
     */
    _clearNotice() {
        const noticeElement = this.querySelector(".delivery-date__notice");
        const noticeText = noticeElement.querySelector(".delivery-date__notice-text");

        noticeText.textContent = "";
        noticeElement.classList.remove("delivery-date__notice--error");
        noticeElement.setAttribute("aria-hidden", "true");
    }

    /**
     * Toggles the loading state of the date picker.
     * @param {Boolean} isLoading whether to show the loading state
     */
    _toggleLoader(isLoading) {
        const datePickerGroup = this.querySelector(".input__datepicker .input__group");

        if (isLoading) {
            datePickerGroup.classList.add("loading");
            this.querySelector("#delivery-date").disabled = true;
        } else {
            datePickerGroup.classList.remove("loading");
            // Only re-enable when a valid zipcode is set
            if (this._zipCode != null) {
                this.querySelector("#delivery-date").disabled = false;
            }
        }
    }

    /**
     * Clears all delivery date related attributes from the cart.
     */
    async _clearDeliveryDateFromCart() {
        await this._setCartAttributes({
            delivery_date: null,
            zip_code: null,
            country: null,
        });
    }
}

customElements.define("delivery-date-picker", DeliveryDatePicker);

/* Afreken-controle (#8053165): 's middags dinsdag gekozen, 's avonds na de cutoff afgerekend, en PPC
   leverde donderdag. De desktopknop roept validateDateSelection() al aan (assets/cart.js), maar de
   mobiele afrekenlinks (<a href="/checkout">) en het afrekenformulier van de drawer niet. Daarom hier,
   in de capture-fase, vóór hun eigen handlers. Alleen bij een verlopen datum grijpen we in. */
(function () {
    // De drawer staat op elke pagina; de zichtbare kiezer krijgt voorrang, zodat de melding verschijnt
    // waar de klant kijkt.
    function verlopenKiezer(binnen) {
        const zichtbaar = (k) => k.getClientRects().length > 0;
        const kiezers = Array.from((binnen || document).querySelectorAll("delivery-date-picker"))
            .filter((k) => typeof k.heeftVerlopenDatum === "function")
            .sort((a, b) => Number(zichtbaar(b)) - Number(zichtbaar(a)));
        return kiezers.find((k) => k.heeftVerlopenDatum()) || null;
    }

    function tegenhouden(e, kiezer) {
        e.preventDefault();
        e.stopImmediatePropagation();
        kiezer.verlopenDatumWissen();
    }

    document.addEventListener(
        "click",
        (e) => {
            const link = e.target && e.target.closest ? e.target.closest('a[href^="/checkout"]') : null;
            if (!link) return;
            const kiezer = verlopenKiezer(document);
            if (kiezer) tegenhouden(e, kiezer);
        },
        true,
    );

    document.addEventListener(
        "submit",
        (e) => {
            const form = e.target;
            // Alleen de afrekenknop; een andere submit van hetzelfde formulier laten we met rust.
            const naarAfrekenen = e.submitter
                ? e.submitter.name === "checkout"
                : !!(form && form.querySelector && form.querySelector('[name="checkout"]'));
            if (!naarAfrekenen) return;
            const kiezer = verlopenKiezer((form.closest && form.closest(".vm-cd")) || document);
            if (kiezer) tegenhouden(e, kiezer);
        },
        true,
    );
})();
